import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { Base, Button, Flex } from '@stepstone-genesis/components';
import { ContentHeading } from '../../components/common/ContentHeading/index.js';
import { ArrowLeftIcon } from '@stepstone-genesis/icons';
import { useTranslation } from '@stepstone-platform/i18n';
import { useEffect } from 'react';
import { HeaderDescription } from '../../components/common/HeaderDescription/index.js';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.js';
import { validateEmail } from '../../helpers/validateEmail.js';
import { ResetPasswordAlert } from '../ResetPassword/components/ResetPasswordAlert/index.js';
import { FORM_TYPES } from '../../types/paramsConfig.js';
import { emailSelector, resetPasswordThunk, } from '../ResetPassword/resetPasswordSlice.js';
import { ResetPasswordEmailInput } from '../ResetPassword/ResetPassword/ResetPasswordEmailInput.js';
import { ResetPasswordButton } from '../ResetPassword/ResetPassword/ResetPasswordButton/index.js';
import { useTrack } from '../../tracking/common/hooks/useTrack.js';
import { setActiveView } from '../../redux/core/wrapperContext/wrapperContextSlice.js';
export const TwoStepResetPassword = () => {
    const { t } = useTranslation();
    const resetPasswordEmail = useAppSelector(emailSelector);
    const dispatch = useAppDispatch();
    const { trackBtnClick, trackModalComponentVisible } = useTrack('resetPassword');
    useEffect(() => {
        trackModalComponentVisible();
    }, []);
    const onSendResetPassword = () => {
        if (resetPasswordEmail && validateEmail(resetPasswordEmail.value)) {
            trackBtnClick({ uniqueName: 'resetPassword' });
            dispatch(resetPasswordThunk(resetPasswordEmail.value));
            return;
        }
    };
    const onBackToLoginClick = () => {
        trackBtnClick({ uniqueName: 'backToLogin' });
        dispatch(setActiveView(FORM_TYPES.TWO_STEP_LOGIN));
    };
    return (_jsxs(Flex, { flxDirection: 'column', gap: 'spaceL', flxItems: 'flex-start', "data-testid": "two-step-reset-password", children: [_jsxs(Base, { children: [_jsx(ContentHeading, { label: t('loginregistration.twoStepLoginRegistration.resetPassword.header') }), _jsx(HeaderDescription, { label: t('loginregistration.twoStepLoginRegistration.resetPassword.headerDescription') })] }), _jsx(ResetPasswordAlert, {}), _jsx(ResetPasswordEmailInput, {}), _jsx(ResetPasswordButton, { onClick: onSendResetPassword }), _jsx(Button, { "data-testid": "two-step-back-to-login-button", a11yLabel: "Back to login button", variant: "link", onClick: onBackToLoginClick, isLoading: false, iconBefore: _jsx(ArrowLeftIcon, {}), children: t('loginregistration.twoStepLoginRegistration.resetPassword.backLink') })] }));
};
//# sourceMappingURL=TwoStepResetPassword.js.map